import { images, translations, type Lang } from "../content";

export default function Footer({ lang }: { lang: Lang }) {
  const t = translations[lang].footer;

  return (
    <footer className="py-12 border-t border-border/10" dir={lang === "he" ? "rtl" : "ltr"}>
      <div className="container mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* The logo is a full lockup, so it is shown on its own rather than
            cropped to a circle beside a duplicate wordmark. */}
        <img
          src={images.logo}
          alt="S.T.Y. Travel"
          className="h-10 md:h-12 w-auto object-contain"
        />
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} S.T.Y. Travel LTD {t.rights}.
        </p>
      </div>
    </footer>
  );
}
